import { DateField } from '@mews-commander/form';
import { useCalendarService } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Stack, StackItem, Title } from '@optimus-web/core';
import { GenerateContractFormStepName, RecipientsFormFields } from '../types';

export const AddDeadlineSection = () => {
    const calendarService = useCalendarService();
    const today = calendarService.getCurrentDate();
    return (
        <Stack vertical spacing="200">
            <Title level={2}>{lt('ContractsGenerateContractDeadlineTitle')}</Title>
            <StackItem maxWidth="250px">
                <DateField
                    mode="iso"
                    minDate={today}
                    label={lt('ContractsGenerateContractSignatureDeadlineLabel')}
                    name={`${GenerateContractFormStepName.Recipients}.${RecipientsFormFields.Deadline}`}
                />
            </StackItem>
        </Stack>
    );
};
